module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs center-xs pl-subheading"
  }, [_c('chart', {
    attrs: {
      "height": 250,
      "type": 'bubble',
      "data": _vm.student_summary_bubble_chart,
      "options": _vm.optionsHeatMapBubble
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-54a46d59!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/studentCommentSummaryGraph.vue
// module id = 1203
// module chunks = 61